import api from '@/modules/axios'
import apiHelperParamsJson from '@/modules/apiHelperParamsJson'

export default {
    history(params) {
        let result = api.get('/message/guest-history', apiHelperParamsJson(params))
        result.then(messages => {
            messages.data.forEach(item => {
                if (item.delivery_status == 0 || item.delivery_status == 3)
                    this.delivered({ message_id: item.id })
            })
        })

        return result
    },
    send(params) {
        return api.post(
            '/message/send-from-guest',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },
    typingLive(message, chatId) {
        if (!chatId) return
        const params = { message, chatId }
        return api.post(
            '/message/guest-typing',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },

    delivered(params) {
        return api.post(
            '/message/delivered',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },
    uploadFile(formData) {
        return api.post('upload/upload/message-file', formData, {
            headers: {
                jsonStringOff: true,
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
